<ng-container *ngIf="params.location === 'header'; else cell">
  <span class="bg-light border border-primary">{{ params.value }}</span>
</ng-container>
<ng-template #cell>
  <div class="bg-light border border-primary" *ngIf="params.type === 'request'">
    <div class="p-1"><b>Source:</b> {{ data.source }}</div>
    <div class="p-1"><b>Originator:</b> {{ data.originator }}</div>
    <div class="p-1" *ngIf="((!!this.params.context.name && (this.params.context.name === 'AVAILABLE_FOR_PLACEMENT' || this.params.context.name === 'RECEIVING_PIPELINE')) && this.params.data.destinationTrack?.name)"><b>To Track:</b> {{ this.params.data.destinationTrack?.name }}</div>
    <div class="p-1" *ngIf="value !== 'Switch Request' && data.spot"><b>To Spot:</b> {{ data.spot }}</div>
    <div class="p-1">
      <b>Request Time:</b> {{ data?.requestTimeStamp !== 0 ? (data.requestTimeStamp | nsDate: 'short') : '' }}
    </div>
    <div class="p-1" *ngIf="value === 'Switch Request' && data.note"><b>Instructions:</b> {{ data.note }}</div>
  </div>
  <div class="bg-light border border-primary" *ngIf="params.type === 'pendingRequest'">
    <div class="p-1"><b>Source:</b> {{ data.pendingRequestOriginator }}</div>
    <div class="p-1"><b>Originator:</b> {{ data.pendOriginatorUname }}</div>
    <div class="p-1" *ngIf="value !== 'Switch Request' && data.spot"><b>To Spot:</b> {{ data.spot }}</div>
    <div class="p-1">
      <b>Request Time:</b> {{ data?.requestTimeStamp !== 0 ? (data.pendingRequestTimestamp | nsDate: 'short') : '' }}
    </div>
    <div class="p-1" *ngIf="value === 'Switch Request' && data.note"><b>Instructions:</b> {{ data.note }}</div>
  </div>
  <div class="bg-light border border-primary" *ngIf="params.type === 'status'">
    <div class="p-1">
      <b>{{ data.statusDescription }}:</b> {{ data?.statusDateTime ? (data.statusDateTime | nsDate: 'short') : '' }}
    </div>
  </div>
  <div class="bg-light border border-primary">
    <div class="p-1" *ngIf="showServiceCredits">{{ serviceCredits[0] }}</div>
    <div class="p-1" *ngIf="showServiceCredits">{{ serviceCredits[1] }}</div>
    <div class="p-1" *ngIf="showAdjustedCredits">{{ data.adjustedCreditToolTip }}</div>
    <div class="p-1" *ngIf="showCredits">{{ data.creditsToolTip || data.creditToolTip }}</div>
    <div class="p-1" *ngIf="showApprovedBy">{{ data.approvedByToolTip || data.approvedBytimeStampDisplay }}</div>
    <div class="p-1" *ngIf="params.type === 'rowDrag'">Select the row(s) and click on the hand icon to drag and drop.</div>
  </div>
</ng-template>
